import * as remoteAction from "../remoteAction";
import { getEmailsFromString } from "../../utils/string";

export type EmailShareActionSuccess = remoteAction.MerchantRemoteResponse<
  "EMAIL_SHARE_SUCCESS",
  any
>;
export type EmailShareActionFailure = remoteAction.MerchantRemoteResponse<
  "EMAIL_SHARE_FAILURE",
  any
>;
export type EmailShareActionRequest = remoteAction.MerchantRemoteResponse<
  "EMAIL_SHARE_REQUEST",
  any
>;

export interface EmailShareAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "EMAIL_SHARE_REQUEST";
    success: "EMAIL_SHARE_SUCCESS";
    failure: "EMAIL_SHARE_FAILURE";
  };
}

export interface EmailShareParams {
  merchantId: string;
  recipients: string[] | string;
  message: string;
  campaignId: string;
  email: string;
  // tslint:disable-next-line:no-any
  [otherProps: string]: any;
}

export const emailShare = (data: EmailShareParams): EmailShareAction | null => {
  if (typeof data.recipients === "string") {
    data.recipients = getEmailsFromString(data.recipients);
  }

  return {
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      request: "EMAIL_SHARE_REQUEST",
      failure: "EMAIL_SHARE_FAILURE",
      success: "EMAIL_SHARE_SUCCESS",
    },
    method: "POST",
    https: true,
    data: { ...data, channel: "email" },
    url: "/share/email",
  };
};
